import { render } from "./ScreenerTable.vue?vue&type=template&id=3bfda03b&scoped=true"
import script from "./ScreenerTable.vue?vue&type=script&lang=js"
export * from "./ScreenerTable.vue?vue&type=script&lang=js"

import "./ScreenerTable.vue?vue&type=style&index=0&id=3bfda03b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfda03b"]])

export default __exports__